"use client";

import { c as _c } from "react/compiler-runtime";
import { getShopConfig } from "@/server/shop/get-shop-config";
export default function ProductOptionPills(t0) {
  const $ = _c(21);
  const {
    product,
    selectedOptions,
    setSelectedOptions,
    setSelectedVariant,
    setQuantity
  } = t0;
  const soptions = product?.variants?.[0]?.options || null;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getShopConfig();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const nshop = t1;
  let t2;
  if ($[1] !== product.variants || $[2] !== selectedOptions || $[3] !== setQuantity || $[4] !== setSelectedOptions || $[5] !== setSelectedVariant) {
    t2 = function handleSelect(optionName, value) {
      const nextOptions = {
        ...selectedOptions,
        [optionName]: value
      };
      setSelectedOptions(nextOptions);
      const matchedVariant = product?.variants?.find(variant => Object.entries(nextOptions).every(t3 => {
        const [key, val] = t3;
        return variant?.option_values?.[key] === val;
      }));
      if (matchedVariant) {
        setSelectedVariant(matchedVariant);
        setQuantity?.(1);
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    $[1] = product.variants;
    $[2] = selectedOptions;
    $[3] = setQuantity;
    $[4] = setSelectedOptions;
    $[5] = setSelectedVariant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSelect = t2;
  let t3;
  if ($[7] !== product.variants || $[8] !== selectedOptions) {
    t3 = function hasStockForValue(optionName_0, value_0) {
      const testOptions = {
        ...selectedOptions,
        [optionName_0]: value_0
      };
      return product?.variants?.some(variant_0 => Object.entries(testOptions).every(t4 => {
        const [key_0, val_0] = t4;
        return variant_0?.option_values?.[key_0] === val_0;
      }) && (variant_0.stock || 0) > 0);
    };
    $[7] = product.variants;
    $[8] = selectedOptions;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const hasStockForValue = t3;
  let t4;
  if ($[10] !== product.title) {
    t4 = <h2 className="text-xl lg:text-2xl"><span className="hidden">{product.title} {" "}</span>Product Options</h2>;
    $[10] = product.title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleSelect || $[13] !== hasStockForValue || $[14] !== product.variants || $[15] !== selectedOptions || $[16] !== soptions) {
    t5 = soptions?.map((optname, index) => {
      const uniqueValues = [...new Set(product?.variants.map(v => v.option_values?.[optname]).filter(Boolean))];
      return <div key={index} className="flex flex-col gap-1 bg-white p-2 shadow rounded mb-2"><h3 className="text-base lg:text-lg">Available {optname}</h3><div className="grid grid-cols-2 lg:grid-cols-6 gap-2">{uniqueValues?.map((opvalue, vidx) => {
            const isSelected = selectedOptions?.[optname] === opvalue;
            hasStockForValue(optname, opvalue);
            return <button type="button" key={vidx} title={opvalue} onClick={() => handleSelect(optname, opvalue)} className={`relative line-clamp-1 cursor-pointer 
                                        ${nshop.id === "pouchandgo" ? "rounded-xl" : "rounded"} px-2 py-1.5 leading-relaxed! text-sm! border border-dotted border-primary shadow/20 shadow-primary transition-colors 
                                        ${isSelected ? "bg-white" : "bg-white"}`}>{opvalue}</button>;
          })}</div></div>;
    });
    $[12] = handleSelect;
    $[13] = hasStockForValue;
    $[14] = product.variants;
    $[15] = selectedOptions;
    $[16] = soptions;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <div className="flex flex-col gap-2">{t4}{t5}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}